export default __webpack_public_path__ + "static/media/step_H_EN.36cc3e38.png";